import React, { useCallback } from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Image } from "hesus-ui-kit";
import { renderPriceWithCurrency } from "@utils/utils";
import transportOnlyIcon from "@icons/ic-transport-only.svg";
import transportTreatmentIcon from "@icons/ic-transportTreatment.svg";
import treatmentOnlyIcon from "@icons/ic-treatment.svg";
import { DivBackgroundOpacity } from "@utils/extra-style";

import {
  GrayDarkerSpan,
  GraySpan,
  PriceContainer,
} from "../../../../Enquiry/EnquiryList/components/EnquirySolutions/EnquirySolutions.styled";
import {
  InfoContainer,
  GridRow,
} from "../../../../Enquiry/EnquiryList/EnquiryList.styled";
import "../../SolutionsList.scss";

const Price = (props) => {
  const { t, solutionData } = props;
  let selectedTransportPrice = [];
  selectedTransportPrice = solutionData?.solutionTransportPrices?.filter(
    (price) => price.selectedPrice
  );

  return (
    <>
      {solutionData?.length !== "" && (
        <DivBackgroundOpacity opacity={solutionData.isActive === 1 ? 1 : "0.2"}>
          <InfoContainer>
            {solutionData.priceType === 3 && (
              <PriceContainer>
                <Image
                  src={transportOnlyIcon}
                  alt={t("TRANSPORT_ONLY")}
                  title={t("TRANSPORT_ONLY")}
                  className="solutions-list__image-icon"
                />
                <GrayDarkerSpan>
                  {selectedTransportPrice.length !== 0 &&
                    renderPriceWithCurrency(
                      selectedTransportPrice?.[0].price,
                      t(selectedTransportPrice?.[0].unit),
                      selectedTransportPrice?.[0].currency.symbol,
                      selectedTransportPrice?.[0].currency.position
                    )}
                </GrayDarkerSpan>
                <GraySpan>
                  {selectedTransportPrice.length !== 0 &&
                    " - " + selectedTransportPrice?.[0].transportType.name}
                </GraySpan>
              </PriceContainer>
            )}
            {solutionData.priceType === 4 && (
              <PriceContainer>
                <Image
                  src={treatmentOnlyIcon}
                  alt={t("TREATMENT_ONLY")}
                  title={t("TREATMENT_ONLY")}
                  className="solutions-list__image-icon"
                />
                <GrayDarkerSpan>
                  {renderPriceWithCurrency(
                    solutionData?.solutionTreatmentPrices?.[0]?.price,
                    t(solutionData?.solutionTreatmentPrices?.[0]?.unit),
                    solutionData?.solutionTreatmentPrices?.[0]?.currency
                      ?.symbol,
                    solutionData?.solutionTreatmentPrices?.[0]?.currency
                      ?.position
                  )}
                </GrayDarkerSpan>
              </PriceContainer>
            )}
            {solutionData.priceType === 1 && (
              <>
                <GridRow>
                  <PriceContainer>
                    <Image
                      src={treatmentOnlyIcon}
                      alt={t("TREATMENT_ONLY")}
                      title={t("TREATMENT_ONLY")}
                      className="solutions-list__image-icon"
                    />
                    <GrayDarkerSpan>
                      {renderPriceWithCurrency(
                        solutionData?.solutionTreatmentPrices?.[0].price,
                        t(solutionData?.solutionTreatmentPrices?.[0].unit),
                        solutionData?.solutionTreatmentPrices?.[0].currency
                          .symbol,
                        solutionData?.solutionTreatmentPrices?.[0].currency
                          .position
                      )}
                    </GrayDarkerSpan>
                  </PriceContainer>
                </GridRow>
                <PriceContainer>
                  <Image
                    src={transportOnlyIcon}
                    alt={t("TRANSPORT_ONLY")}
                    title={t("TRANSPORT_ONLY")}
                    className="solutions-list__image-icon"
                  />
                  <GrayDarkerSpan>
                    {solutionData.solutionStatus !== 5 &&
                      selectedTransportPrice.length !== 0 &&
                      renderPriceWithCurrency(
                        selectedTransportPrice?.[0].price,
                        t(selectedTransportPrice?.[0].unit),
                        selectedTransportPrice?.[0].currency.symbol,
                        selectedTransportPrice?.[0].currency.position
                      )}
                    {solutionData.solutionStatus === 5 && "?"}
                  </GrayDarkerSpan>
                  <GraySpan>
                    {selectedTransportPrice.length !== 0 &&
                      " - " + selectedTransportPrice?.[0].transportType.name}
                  </GraySpan>
                </PriceContainer>
              </>
            )}
            {solutionData.priceType === 2 && (
              <PriceContainer>
                <Image
                  height="25px"
                  width="45px"
                  src={transportTreatmentIcon}
                  alt={t("TREATMENT_TRANSPORT_PRICE")}
                  title={t("TREATMENT_TRANSPORT_PRICE")}
                  className="solutions-list__image-icon"
                />
                <GrayDarkerSpan>
                  {solutionData.solutionStatus !== 5 &&
                    selectedTransportPrice.length !== 0 &&
                    renderPriceWithCurrency(
                      selectedTransportPrice?.[0].price,
                      t(selectedTransportPrice?.[0].unit),
                      selectedTransportPrice?.[0].currency.symbol,
                      selectedTransportPrice?.[0].currency.position
                    )}
                  {solutionData.solutionStatus === 5 && "?"}
                </GrayDarkerSpan>
                <GraySpan>
                  {selectedTransportPrice.length !== 0 &&
                    " - " + selectedTransportPrice?.[0].transportType.name}
                </GraySpan>
              </PriceContainer>
            )}
          </InfoContainer>
        </DivBackgroundOpacity>
      )}
    </>
  );
};

Price.propTypes = {
  solutionData: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Price);
